import React from "react";
import { Link } from "react-router-dom";
import { Instagram, ArrowUpRight } from "lucide-react";
import { Logo } from "./Logo";
import { LINKS } from "../lib/constants";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-ink text-paper">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          <div>
            <Link to="/" className="inline-flex">
              <Logo dark showTagline className="h-9" />
            </Link>
            <p className="font-sans text-paper/60 mt-6 max-w-sm leading-relaxed">
              Soul &amp; Service, in motion. Bringing LSU students together through line dancing,
              culture, and community impact.
            </p>
          </div>

          <div className="flex flex-col md:items-end gap-4 font-sans">
            <a
              href={LINKS.instagram}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram"
              className="inline-flex items-center gap-2 text-paper/80 hover:text-white transition-colors"
            >
              <Instagram size={18} /> Instagram
            </a>
            <a
              href={LINKS.tigerlink}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-tigerlink"
              className="inline-flex items-center gap-2 text-paper/80 hover:text-white transition-colors"
            >
              TigerLink <ArrowUpRight size={16} />
            </a>
            <a
              href={`mailto:${LINKS.email}`}
              data-testid="footer-email"
              className="text-paper/80 hover:text-white transition-colors"
            >
              {LINKS.email}
            </a>
            <Link
              to="/admin"
              data-testid="footer-admin-login"
              className="text-paper/40 hover:text-paper/80 transition-colors text-sm mt-2"
            >
              Admin Login
            </Link>
          </div>
        </div>

        <div className="border-t border-paper/10 mt-14 pt-8 flex flex-col md:flex-row justify-between gap-3 text-paper/40 text-sm font-sans">
          <span>© {new Date().getFullYear()} Tiger Trailride · LSU</span>
          <Link to="/links" data-testid="footer-links" className="hover:text-paper/70 transition-colors">
            Link in bio
          </Link>
        </div>
      </div>
    </footer>
  );
};
